import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Divider } from '@ui/components/Divider'
import { Modal } from '@ui/components/Modal'

export const TwoFAInfoModal: BaseModalType = ({ close }) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('TwoFactorAuth.Two-step authentication')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.TitleTextBox>
          <Modal.Body.Title>{t('Profile.What is Two-step verification?')}</Modal.Body.Title>
          <Modal.Body.Text>
            {t(
              'Profile.A feature that helps you get access to your Client Area with improved security and minimising the security breach threats'
            )}
          </Modal.Body.Text>
        </Modal.Body.TitleTextBox>
        <Divider.Horizontal rounded />
        <Modal.Body.TitleTextBox>
          <Modal.Body.Title>{t('Profile.How does it work?')}</Modal.Body.Title>
          <Modal.Body.Text>
            {t(
              'Profile.Once enabled, a verification code will be sent to you via your selected method every time you log in'
            )}
          </Modal.Body.Text>
        </Modal.Body.TitleTextBox>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
